import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { gsap } from "gsap";
import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";
// import { sound } from "../../core/Sound"; // adjust path if needed

export class Trails extends DisplayObject {
    private spineData: any = {
        skeleton: "trailSkel",
        atlas: "trailAtlas",
    };
    private meterEffectData: any = {
        skeleton: "meterEffectSkel",
        atlas: "meterEffectAtlas",
    };

    constructor(config: IDisplayObject) {
        super(config);
    }

    public triggerTrail(
        symbol: Spine,
        meter: Spine,
        // id: number,
        callback: () => void
    ) {
        this.updateTransform({});

        const startLocal = this.toLocal(
            symbol.toGlobal({ x: 0, y: 0 })
        );

        const hitBone = meter.skeleton.findBone("big_special_symbol_active");

        let endLocal;

        if (hitBone) {
            const globalHitPos = meter.toGlobal({
                x: hitBone.worldX,
                y: hitBone.worldY,
            });

            endLocal = this.toLocal(globalHitPos);
        } else {
            console.warn("hit point not found");

            endLocal = this.toLocal(
                meter.toGlobal({ x: 0, y: 0 })
            );
        }

        const trail = Spine.from(this.spineData);
        this.addChild(trail);

        const baseScaleX = 1;
        const baseScaleY = 0.5;

        trail.scale.set(baseScaleX, baseScaleY);

        const bounds = trail.getLocalBounds();
        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        trail.pivot.set(
            bounds.x + bounds.width / 2,
            bounds.y + bounds.height / 2
        );

        trail.position.set(
            startLocal.x,
            startLocal.y
        );


        const dx = endLocal.x - startLocal.x;
        const dy = endLocal.y - startLocal.y;
        const angle = Math.atan2(dy, dx);

        trail.rotation = angle + Math.PI / 2;

        trail.state.setAnimation(0, "animation", false);
        // trail.state.addAnimation(0, "loop", true);


        const duration = isSuperQuickBtnOnGlobal ? 0.25 : 0.5;

        const moveObj = {
            x: startLocal.x,
            y: startLocal.y,
        };
        let hasHitTriggered = false;

        gsap.to(moveObj, {
            x: endLocal.x,
            y: endLocal.y,
            duration,
            ease: "none",
            delay: 0.1,

            onStart: () => {
                // sound.play("egg_firing", {
                //     volume: 1,
                //     speed: isSuperQuickBtnOnGlobal ? 1.5 : 1,
                // });
                sound.play(SoundConstants.SCARAB_FIRE, { volume: 0.7, speed: timeScale });
            },

            onUpdate: () => {

                const dx = moveObj.x - trail.x;
                const dy = moveObj.y - trail.y;
                const angle = Math.atan2(dy, dx);

                trail.rotation = angle + Math.PI / 2;


                const progress =
                    Math.abs(moveObj.x - startLocal.x) /
                    Math.abs(endLocal.x - startLocal.x || 1);

                const scaleBoost =
                    1 + 0.35 * Math.sin(progress * Math.PI);

                trail.scale.set(
                    baseScaleX * scaleBoost,
                    baseScaleY * scaleBoost
                );


                trail.x = moveObj.x;
                trail.y = moveObj.y;

                const distanceToTarget = Math.hypot(
                    endLocal.x - moveObj.x,
                    endLocal.y - moveObj.y
                );

                if (!hasHitTriggered && distanceToTarget <= 2) {
                    hasHitTriggered = true;
                    this.playMeterHitEffect(endLocal);
                    if (callback) callback();
                }
            },

            onComplete: () => {
                trail.destroy({ children: true });
                // trail.state.setAnimation(0, 'out', false);
                // trail.state.addListener({
                //     complete: (entry) => {
                //         if (entry.animation.name === 'out') {
                //             trail.destroy({ children: true });
                //         }
                //     }
                // });

            }
        });
    }

    private playMeterHitEffect(position: { x: number; y: number }) {
        const meterEffect = Spine.from(this.meterEffectData);
        meterEffect.scale.set(0.4);
        meterEffect.position.set(position.x, position.y);
        this.addChild(meterEffect);

        let isCleaned = false;
        const cleanup = () => {
            if (isCleaned) return;
            isCleaned = true;
            meterEffect.state.clearListeners();
            meterEffect.destroy({ children: true });
        };

        meterEffect.state.addListener({
            complete: cleanup,
        });
        meterEffect.state.setAnimation(0, "animation", false);
    }
}